import AddressRelatedContactsModal from './address_related_contacts_modal';

export default AddressRelatedContactsModal;
